module.exports = __webpack_public_path__ + "img/img_nav_sale-w.ce0fd7f5.svg";